<h1 mat-dialog-title>{{ 'labels.heading.Change Password' | translate }}</h1>

<div mat-dialog-content>
  <form [formGroup]="changePasswordForm" class="layout-column" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ 'labels.inputs.Password Current' | translate }}</mat-label>
      <input matInput type="password" formControlName="currentPassword" required />
      @if (changePasswordForm.get('currentPassword')?.hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Password Current Required' | translate }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ 'labels.inputs.Password New' | translate }}</mat-label>
      <input matInput type="password" formControlName="password" required />
      @if (changePasswordForm.get('password')?.errors) {
        <mat-error>
          {{ 'labels.commons.Password validation' | translate: { minchar: minPasswordLength } }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ 'labels.inputs.Repeat Password' | translate }}</mat-label>
      <input matInput type="password" formControlName="repeatPassword" required />
      @if (changePasswordForm.get('repeatPassword')?.hasError('notequal')) {
        <mat-error>
          {{ 'inputs.passwordsDoNotMatch' | translate }}
        </mat-error>
      }
    </mat-form-field>
    <mat-dialog-actions align="center">
      <button mat-raised-button color="warn" type="button" (click)="dialogRef.close()">
        {{ 'labels.buttons.Cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!changePasswordForm.valid">
        {{ 'labels.buttons.Confirm' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
